/*eslint no-unused-vars: [0]*/
import { put } from "redux-saga/effects";

import { updateOrder } from "../actions";

export function* checkoutSaga(action) {
	try {
		yield put(updateOrder(action.checkoutFormData));
	} catch (error) {
		console.log(error)
	}
}
